function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26 17a1 1 0 011 1v8a1 1 0 01-1 1h-8a1 1 0 01-1-1v-8a1 1 0 011-1zm-15.5 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9zM25 19h-6v6h6v-6zm-14.5 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM15 6a1 1 0 011 1v8a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1zm6.793.257a1 1 0 011.414 0l3.536 3.536a1 1 0 010 1.414l-3.536 3.536a1 1 0 01-1.414 0l-3.536-3.536a1 1 0 010-1.414zM14 8H8v6h6V8zm8.5.379L20.379 10.5l2.121 2.121 2.121-2.121L22.5 8.379z",
  fill: "#000",
  fillRule: "nonzero"
});

function SvgIcMisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcMisc;